module.exports = __webpack_public_path__ + "img/lemniscata_gmt.b55f58e9.gif";